// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBarRadio_wrapper__xEUyX","checked":"SideBarRadio_checked__MM4yG","label":"SideBarRadio_label__fWSAe","icon":"SideBarRadio_icon__jyOdE"};